module.exports = __webpack_public_path__ + "static/media/logo.a1e60904.png";